// Where a visitor came from, kept for the visit and sent with every sign-up and order (marketing plan fix 3, Claudia 2026-10-31):
// ?src= or utm_source on the address they landed on, else the site that linked here. First touch wins. Only a short label,
// never anything personal; without one the sign-up or order says 'site'.
import { readSourceParam } from '../components/vsp/vspFormat';
import { loadSource, rememberSource } from '../components/vsp/vspSession';

function fromReferrer() {
  try {
    const host = new URL(document.referrer).hostname.toLowerCase().replace(/^(www|m|l)\./, '');
    // the site itself, and Stripe sending a buyer back after paying, are not where anyone came from
    if (host === window.location.hostname.replace(/^www\./, '') || /(^|\.)(ivyastrology|stripe)\.com$/.test(host)) return null;
    // the phone apps show up as android-app://com.google.android.youtube and the like
    if (/youtube|youtu\.be/.test(host)) return 'youtube';
    if (/instagram/.test(host)) return 'instagram';
    if (/tiktok|musically/.test(host)) return 'tiktok';
    if (/facebook|fb\.com/.test(host)) return 'facebook';
    if (/^google\.|googlequicksearchbox/.test(host)) return 'google-search';
    return host.replace(/[^a-z0-9_.-]/g, '').slice(0, 40) || null;
  } catch (e) {
    return null; // no referrer
  }
}

/** Once, as the site loads: later pages of the visit no longer have the landing address. */
export function captureTrafficSource() {
  rememberSource(readSourceParam(window.location.search) || fromReferrer());
}

export const trafficSource = () => loadSource() || 'site';
